export default "__VITE_ASSET__BJO7g4DZ__"